/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react'

import { useHistory } from 'react-router-dom'
import { useCallbackNative } from 'components/hooks/useCallbackNative'
import {
  EMAIL_REVALIDACAO_REENVIO,
  EMAIL_REINICIAR_FICHA,
  EMAIL_REVALIDACAO,
} from 'components/urls'
import { TSendDataNative, sendDataNative } from 'components/hooks/useFetchNative'
import { getRouter, RoutesEnum } from 'enums/routes.enum'
import { ITrackEvent, TrackEventEnum } from 'interfaces/trackEvent.interface'
import { GenericRes, ApiResponse, ApiError, IApiResponseCtx } from 'interfaces/response.interface'
import { ResponseEmpty } from 'interfaces/responseEmpty.interface'
import { ApiResponseCtx, DadosPessoaisCtx } from 'App'
import {
  PageContainer,
  Button,
  ButtonWrapper,
  InputAuthentication,
  BoxCenter,
  PageText,
  Text,
  Spacing,
} from 'components'
import { TWO_SECONDS } from 'shared/functions/constants'
import { sendToNewRelic } from 'services'
import url from 'shared/functions/url'
import { IDadosPessoaisCtx } from 'interfaces/dadosPessoais.interface'
import { ellipsis } from 'shared/functions/utils'
import { TErrorObject } from 'components/elements/InputAuthentication'
import { getUrlParams } from 'shared/helpers/getUrlPrams'

import { BottomSheet } from '@inter/inter-ui'

const ReiniciarFicha = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingRestart, setLoadingRestart] = useState<boolean>(false)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [PIN, setPIN] = useState<string>('')
  const [error, setError] = useState<TErrorObject>({} as TErrorObject)

  const { dadosPessoais }: IDadosPessoaisCtx = useContext<IDadosPessoaisCtx>(DadosPessoaisCtx)

  const clearError = () => {
    setError({ ...error, token: undefined })
  }

  const { setApiResponse }: IApiResponseCtx = useContext<IApiResponseCtx>(ApiResponseCtx)
  const history = useHistory()

  useEffect(() => {
    if (PIN) {
      setLoading(true)
      clearError()
      const callApi: TSendDataNative = {
        body: { token: PIN },
        callback: 'callbackApiRestartEmail',
        endpoint: EMAIL_REVALIDACAO,
        method: 'POST',
      }
      sendDataNative(callApi)
      setTimeout(() => {
        setLoading(false)
      }, TWO_SECONDS)
    }
  }, [PIN])

  useCallbackNative('callbackApiRestartEmail', 'onCallbackApiRestartEmail', {
    onCallbackApiRestartEmail: (data: GenericRes) => {
      if (data instanceof ApiResponse) {
        const step = getRouter(data.telas.stepList[0].step)
        let newStep = step as string
        const urlStepList = data.telas.stepList[0].url

        sendToNewRelic('REVALIDAR_PIN_EMAIL', '[ApiResponse] - callbackApiRestartEmail', {
          PROXIMA_ETAPA: step,
          URL: urlStepList,
        })

        if (step) {
          if (step === RoutesEnum.AVISO_REFAZER_ITENS) {
            setApiResponse({
              ...data,
              telas: {
                ...data.telas,
                stepList: data.telas?.stepList?.splice(1),
              },
            })
          }

          if (step === RoutesEnum.STEP_ESCOLHA_CARTAO) {
            const urlParams = urlStepList.split('/#/')[1]
            const hasQuestionMark = urlParams.includes('?')

            newStep = `/${urlParams}${url.buildQuery({ nome: data.nome }, hasQuestionMark)}`
          }

          history.push(step === RoutesEnum.STEP_ESCOLHA_CARTAO && newStep ? newStep : step)
        } else {
          sendDataNative({
            body: data,
            callback: 'callbackMediaUpdate',
            endpoint: '',
            method: 'CALLMEDIAUPDATE',
          })
        }
      } else if (data instanceof ApiError) {
        setError(data)
        sendToNewRelic('REVALIDAR_PIN_EMAIL', '[ApiError] - callbackApiRestartEmail', {
          response: JSON.stringify(data),
        })
      }
      setLoading(false)
    },
  })

  useCallbackNative('callbackSendBackApiEmpty', 'onCallbackSendBackApiEmpty', {
    onCallbackSendBackApiEmpty: (data: GenericRes) => {
      setLoading(false)
      if (data instanceof ApiResponse) {
        const step = getRouter(data.telas.stepList[0].step)

        sendToNewRelic(
          'REVALIDAR_PIN_EMAIL_REINICIAR_ABERTURA',
          '[ApiResponse] - callbackSendBackApiEmpty',
          {
            PROXIMA_ETAPA: step,
            URL: data.telas.stepList[0].url,
          },
        )
        if (step) {
          history.push(`${step}${url.buildQuery(getUrlParams(data.telas.stepList[0].url))}`)
        } else {
          sendDataNative<TSendDataNative>({
            callback: 'restartOnboarding',
            endpoint: '',
            method: 'RESTARTONBOARDING',
          })
        }
      } else if (data instanceof ResponseEmpty) {
        sendDataNative<TSendDataNative>({
          callback: 'restartOnboarding',
          endpoint: '',
          method: 'RESTARTONBOARDING',
        })
      }
      if (!(data as ApiError)?.httpCodigo || !(data as ApiError)?.campo) {
        sendDataNative<TSendDataNative>({
          callback: 'restartOnboarding',
          endpoint: '',
          method: 'RESTARTONBOARDING',
        })
      } else {
        sendToNewRelic(
          'REVALIDAR_PIN_EMAIL_REINICIAR_ABERTURA',
          '[ApiError] - callbackSendBackApiEmpty',
          {
            response: JSON.stringify(data),
          },
        )
      }
      setLoadingRestart(false)
    },
  })

  const reSend = () => {
    setLoading(true)
    clearError()
    const callApi: TSendDataNative = {
      callback: 'callbackApiEmpty',
      endpoint: EMAIL_REVALIDACAO_REENVIO,
      method: 'POSTWRESPONSE',
    }
    sendDataNative(callApi)
    sendDataNative<ITrackEvent>({
      method: 'TRACKEVENT',
      body: {
        name: TrackEventEnum.TELA_REVALIDAR_EMAIL_REENVIAR,
        parameters: {},
      },
    })
    setTimeout(() => {
      setLoading(false)
    }, TWO_SECONDS)
    sendToNewRelic('REVALIDAR_PIN_EMAIL', 'Envio de Token')
  }

  const sendBackToPrevStep = () => {
    setLoadingRestart(true)
    const callApi: TSendDataNative = {
      callback: 'callbackSendBackApiEmpty',
      endpoint: EMAIL_REINICIAR_FICHA,
      method: 'POSTWRESPONSE',
    }
    sendDataNative(callApi)
    sendDataNative<ITrackEvent>({
      method: 'TRACKEVENT',
      body: {
        name: TrackEventEnum.TELA_REVALIDAR_EMAIL_POPUP_CONTINUAR,
        parameters: {},
      },
    })
    sendToNewRelic('REVALIDAR_PIN_EMAIL', 'Reiniciar com outro email')
  }

  const closePopUp = () => {
    setOpenModal(false)
    sendDataNative<ITrackEvent>({
      method: 'TRACKEVENT',
      body: {
        name: TrackEventEnum.TELA_REVALIDAR_EMAIL_POPUP_VOLTAR,
        parameters: {},
      },
    })
  }

  const onNoAccessEmail = () => {
    setOpenModal(true)
    sendDataNative<ITrackEvent>({
      method: 'TRACKEVENT',
      body: {
        name: TrackEventEnum.TELA_REVALIDAR_EMAIL_SEM_ACESSO,
        parameters: {},
      },
    })
  }

  useEffect(() => {
    reSend()
  }, [])

  return (
    <PageContainer>
      <PageText text="Agora enviamos um código para o seu e-mail" margin="80px 0px 24px 0px" />

      <Text variant="body-3">
        Digite o código enviado para o e-mail{` `}
        {dadosPessoais?.email && <strong>{ellipsis(dadosPessoais.email, 30)}</strong>}.
      </Text>

      <Spacing mt="lg" mb="lg">
        <BoxCenter>
          <InputAuthentication callbackValue={setPIN} error={error} />
        </BoxCenter>
      </Spacing>

      <BoxCenter>
        <Button variant="secondary" isLoading={loading} onClick={reSend}>
          Reenviar código 30s
        </Button>
      </BoxCenter>

      <ButtonWrapper>
        <Button variant="link" onClick={onNoAccessEmail}>
          Não tenho acesso ao e-mail
        </Button>
      </ButtonWrapper>

      {openModal && (
        <BottomSheet onClose={closePopUp}>
          <h3>Não tenho acesso ao e-mail</h3>
          <p className="mb-4">
            Você pode reiniciar o processo de abertura da conta com outro e-mail. Quer mesmo
            reiniciar?
          </p>

          <ButtonWrapper>
            <Button isLoading={loadingRestart} onClick={sendBackToPrevStep}>
              Reiniciar
            </Button>
            <Button variant="secondary" onClick={closePopUp}>
              Voltar
            </Button>
          </ButtonWrapper>
        </BottomSheet>
      )}
    </PageContainer>
  )
}

export default ReiniciarFicha
